var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { size } from 'polished';
import css from '@emotion/css';
import styled from '@emotion/styled';
import { borderRadius, color, fontWeight, justifyContent, textAlign, themeGet, } from 'styled-system';
import { font } from '../../theme/helper';
import { ButtonBase, SPINNER_SIZE } from './Base';
export var ButtonGreen = styled(ButtonBase)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  [role='progressbar'] svg {\n    ", ";\n    stroke: ", ";\n  }\n\n  cursor: ", ";\n\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  [role='progressbar'] svg {\n    ", ";\n    stroke: ", ";\n  }\n\n  cursor: ",
    ";\n\n  ",
    "\n"])), color, fontWeight, textAlign, justifyContent, borderRadius, function (props) { return font(props.fontSize || 3, props.lineHeight)(props); }, function (_a) {
    var spinnerSize = _a.spinnerSize;
    return size(spinnerSize || SPINNER_SIZE);
}, themeGet('colors.white'), function (_a) {
    var isLoading = _a.isLoading, disabled = _a.disabled;
    return isLoading || !disabled ? 'pointer' : 'auto';
}, function (props) {
    return !props.disabled
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          &:active {\n            background-color: ", ";\n          }\n        "], ["\n          &:active {\n            background-color: ", ";\n          }\n        "])), themeGet('colors.green.80')(props)) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          color: ", ";\n          [role='progressbar'] svg {\n            stroke: ", ";\n          }\n        "], ["\n          color: ", ";\n          [role='progressbar'] svg {\n            stroke: ", ";\n          }\n        "])), themeGet('colors.white')(props), themeGet('colors.white')(props));
});
ButtonGreen.defaultProps = __assign(__assign({}, ButtonBase.defaultProps), { backgroundColor: 'green.60', px: 'sp_16', py: 'sp_8', color: 'white', fontWeight: 'bold', textAlign: 'center', justifyContent: 'center', borderRadius: 'br_3' });
var templateObject_1, templateObject_2, templateObject_3;
